export const addToCartProps = () => ({
  shopHasClickAndCollect: {
    type: Boolean,
    required: false,
    default: false
  },
  shopHasLdd: {
    type: Boolean,
    required: false,
    default: false
  },
  shopHasClickAndCollectTraiteur: {
    type: Boolean,
    required: false,
    default: false
  },
  shopHasClickAndCollectTraiteurNoel: {
    type: Boolean,
    required: false,
    default: false
  },
  isNational: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const addToCartEmits = () => ([
  "setQuantity",
  "removeItem"
])

export const useAddToCart = (props, context) => {
  const setQuantity = (qty, typePanier) => {
    context.emit('setQuantity', qty, typePanier);
  }
  const removeItem = () => {
    context.emit("removeItem");
  }

  const isDrive = computed(() => {
    return props.article.attributes.types_panier && props.article.attributes.types_panier.includes("drive");
  })
  const isClickAndCollect = computed(() => {
    if (props.isNational) {
      return props.article.attributes.types_panier && props.article.attributes.types_panier.includes("click_and_collect") && !props.isClientPro;
    }
    return props.article.attributes.types_panier && props.article.attributes.types_panier.includes("click_and_collect") && !props.isClientPro && props.shopHasClickAndCollect;
  })
  const isClickAndCollectTraiteur = computed(() => {
    if (props.isNational) {
      return props.article.attributes.types_panier && props.article.attributes.types_panier.includes("click_and_collect_traiteur_permanent") && !props.isClientPro;
    }
    return props.article.attributes.types_panier && props.article.attributes.types_panier.includes("click_and_collect_traiteur_permanent") && !props.isClientPro && props.shopHasClickAndCollectTraiteur;
  })
  const isClickAndCollectTraiteurNoel = computed(() => {
    if (props.isNational) {
      return props.article.attributes.types_panier && props.article.attributes.types_panier.includes("click_and_collect_traiteur_noel") && !props.isClientPro;
    }
    return props.article.attributes.types_panier && props.article.attributes.types_panier.includes("click_and_collect_traiteur_noel") && !props.isClientPro && props.shopHasClickAndCollectTraiteurNoel;
  })
  const isLdd = computed(() => {
    return props.article.attributes.types_panier && props.article.attributes.types_panier.includes("ldd");
  })
  const isCKDO = computed(() => {
    return props.article && props.article.attributes.type === 'CKDO';
  });
  const showTypeDrive = computed(() => {
    return isDrive.value;
  })
  const showTypeClickAndCollect = computed(() => {
    return isClickAndCollect.value;
  })
  const showTypeTraiteur = computed(() => {
    return isClickAndCollectTraiteur.value;
  })
  const showTypeTraiteurNoel = computed(() => {
    return isClickAndCollectTraiteurNoel.value;
  })
  const hasMultiplePaniers = computed(() => {
    const showPanier = [isDrive.value, isClickAndCollect.value, isClickAndCollectTraiteur.value, isClickAndCollectTraiteurNoel.value, isLdd.value];
    const trueValues = showPanier.filter(value => value === true);
    return trueValues.length >= 2;
  })
  const isClickAndCollectTraiteurWithoutPro = computed(() => {
    return (props.article.attributes.types_panier && props.article.attributes.types_panier.includes("click_and_collect_traiteur_permanent"));
  })
  const isClickAndCollectTraiteurNoelWithoutPro = computed(() => {
    return (props.article.attributes.types_panier && props.article.attributes.types_panier.includes("click_and_collect_traiteur_noel"));
  })
  const isClickAndCollectOnly = computed(() => {
    return (props.article.attributes.types_panier && props.article.attributes.types_panier.includes("click_and_collect") && props.article.attributes.types_panier.length === 1);
  })
  const isLddOnly = computed(() => {
    return (isLdd.value && props.article.attributes.types_panier.length === 1);
  })
  const isNotEligibleClickAndCollect = computed(() => {
    return ((props.isClientPro && (isClickAndCollectOnly.value || isClickAndCollectTraiteurNoelWithoutPro.value || isClickAndCollectTraiteurWithoutPro.value)) ||
      (isClickAndCollectOnly.value && !props.shopHasClickAndCollect) ||
      (isClickAndCollectTraiteurWithoutPro.value && !props.shopHasClickAndCollectTraiteur) ||
      (isClickAndCollectTraiteurNoelWithoutPro.value && !props.shopHasClickAndCollectTraiteurNoel)) && !props.isNational;
  })
  const isNotEligibleLdd = computed(() => {
    return ((props.isClientPro && isLddOnly.value) || (isLddOnly.value && !props.shopHasLdd));
  })

  return {
    isCKDO,
    setQuantity,
    removeItem,
    showTypeDrive,
    showTypeClickAndCollect,
    showTypeTraiteur,
    showTypeTraiteurNoel,
    isClickAndCollectTraiteurWithoutPro,
    isClickAndCollectTraiteurNoelWithoutPro,
    isDrive,
    isClickAndCollect,
    isClickAndCollectTraiteur,
    isClickAndCollectTraiteurNoel,
    isLdd,
    isLddOnly,
    isNotEligibleClickAndCollect,
    isClickAndCollectOnly,
    isNotEligibleLdd,
    hasMultiplePaniers
  }
}